/**
 * Start Training Battle Service
 *
 * Starts a training battle and returns the complete battle log.
 */

import { WebAppRoutes } from "types/web-app";

import { fetchWithAuth } from "@/providers/auth-provider";

import type { ServiceResponse } from "@/types/services";
import type { CompleteBattleLog } from "types/battle-engine";

export interface StartTrainingBattleInput {
  pokemon_ids: number[];
  mode: "quick_training";
  format?: "1v1" | "3v3";
  cpu_type?:
    | "random"
    | "clone"
    | "neutral"
    | "advantage"
    | "disadvantage"
    | "custom";
  custom?: {
    teamA: Array<{ base_pokemon_name: string; active_skills?: string[] }>;
    teamB: Array<{ base_pokemon_name: string; active_skills?: string[] }>;
  };
}

export interface StartTrainingBattleOutput {
  battle_log: CompleteBattleLog;
  bot_name: string;
  bot_country: string | null;
}

export const startTrainingBattle = async (
  accessToken: string,
  input: StartTrainingBattleInput,
): Promise<ServiceResponse<StartTrainingBattleOutput>> => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.START_TRAINING_BATTLE,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<StartTrainingBattleOutput>;
  } catch (error) {
    console.error("Error starting training battle:", error);
    return {
      ok: false,
      message: error instanceof Error ? error.message : "Failed to start training battle",
      data: null,
    };
  }
};
